import {
  SET_BANK_DETAIL,
  SetBankDetailAction,
} from "../actions/BankDetailActions";
import { IBankDetail } from "../types/bankDetail";

const initialState: IBankDetail = {
  BankName: "",
  AccountType: "",
  AccountIDType: "",
  AccountHolder: "",
  AccountPassport: "",
  AccountIDNumber:  "",
  AccountNumber: "",
  ClaimStatus: "",
  Notes: "",
};

 const bankDetailReducer = (
  state = initialState,
  action: SetBankDetailAction
): IBankDetail => {
  switch (action.type) {
    case SET_BANK_DETAIL:
      return { ...state, ...action.payload };
    // Handle other action types
    default:
      return state;
  }
};
export default bankDetailReducer;